import {
  IconButton as ChakraIconButton,
  IconButtonProps as ChakraIconButtonProps,
} from '@chakra-ui/react';

type IconButtonProps = ChakraIconButtonProps & {
  ref?: React.RefObject<HTMLButtonElement>;
};

export const IconButton = ({
  ref,
  children,
  onClick,
  disabled,
  colorPalette = 'gray',
  ...props
}: IconButtonProps) => {
  return (
    <ChakraIconButton
      onClick={onClick}
      ref={ref}
      borderRadius="md"
      colorPalette={colorPalette}
      {...(disabled && {
        ['data-disabled']: true,
        onClick: (event) => event.preventDefault(),
      })}
      {...props}
    >
      {children}
    </ChakraIconButton>
  );
};
